import { render, staticRenderFns } from "./editItem.vue?vue&type=template&id=d1fdedc0&scoped=true&"
import script from "./editItem.vue?vue&type=script&lang=js&"
export * from "./editItem.vue?vue&type=script&lang=js&"
import style0 from "./editItem.vue?vue&type=style&index=0&id=d1fdedc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fdedc0",
  null
  
)

export default component.exports